import React, { useState } from 'react';

const SearchSuggestions = ({ query, searchTerm, setSearchTerm, suggestionsLength, zIndex = 9000, placeholder = "Search...", disabled = false, onSelect }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);

    const handleSearchChange = (e) => {
        if (disabled) return; // Don't handle changes when disabled

        const value = e.target.value;
        setSearchTerm(value);
        if (Array.isArray(query) && value.length > 0) {
            const filteredSuggestions = query.filter(item => {
                // Handle both username and name properties
                const searchProperty = item.username || item.name;
                return searchProperty && searchProperty.toLowerCase().includes(value.toLowerCase());
            });
            setSuggestions(filteredSuggestions);
            setSelectedSuggestionIndex(-1); // Reset the selected suggestion index
        } else {
            setSuggestions([]);
        }
    };

    const handleSuggestionSelect = (suggestion) => {
        if (disabled) return;

        const displayName = suggestion.username || suggestion.name;
        setSearchTerm(displayName);
        setSuggestions([]);

        // Call onSelect callback if provided
        if (onSelect) {
            onSelect(suggestion);
        }
    };

    const handleKeyDown = (e) => {
        if (disabled) return; // Don't handle key events when disabled

        if (e.key === 'ArrowDown') {
            setSelectedSuggestionIndex(prevIndex => {
                const newIndex = Math.min(prevIndex + 1, suggestions.length - 1, suggestionsLength - 1);
                return newIndex;
            });
        } else if (e.key === 'ArrowUp') {
            setSelectedSuggestionIndex(prevIndex => Math.max(prevIndex - 1, 0));
        } else if (e.key === 'Enter' && selectedSuggestionIndex >= 0 && suggestions[selectedSuggestionIndex]) {
            handleSuggestionSelect(suggestions[selectedSuggestionIndex]);
        }
    };

    return (
        <div className='search-suggestions'>
            <input
                className='market-searchbar'
                style={{ zIndex: zIndex + 1 }}
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={() => !disabled && setIsInputFocused(true)}
                onBlur={() => !disabled && setIsInputFocused(false)}
                onKeyDown={handleKeyDown}
                spellCheck="false"
                autoCorrect="off"
                disabled={disabled}
                readOnly={disabled}
            />
            {suggestions.length > 0 && isInputFocused && !disabled && (
                <div className='suggestions-list' style={{ zIndex: zIndex }}>
                    {suggestions.slice(0, suggestionsLength).map((suggestion, index) => (
                        <p
                            key={index}
                            onMouseDown={() => !disabled && handleSuggestionSelect(suggestion)}
                            className={index === selectedSuggestionIndex ? 'selected-suggestion' : ''}
                        >
                            {suggestion.username || suggestion.name}
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SearchSuggestions;